import { httpRequest } from './../util/Helper.js';
import EventDispatcher from './../studio/service/EventDispatcher.js';

export default class Auth {
    constructor() {
        this.request = httpRequest;
        this.apiBase = process.env.API_BASE.replace(/\/$/, "");
        this.isLoggedIn = false;
        this.dispatcher = new EventDispatcher(true);
        this.dispatcher.setEventTypes([
            "logged_in",
            "logging_in",
            "logged_out",
            "unauthorized"
        ]);
        if (localStorage.getItem('DAStudioAuthToken') !== null){
            this.isLoggedIn = true;
            this.dispatcher.dispatch("logged_in");
        }
    }
    
    authorizedRequest(url, options, callback, onProgress) {
        this.checkRequest();
        this.request(url,options,(res) => {
            if (res.error !== undefined && res.error !== null) {
                let err = res.error.error;
                console.log("Unauthorized call");
                if (err.code === 4){
                    this.refreshToken((payload) => {
                        if (payload) {
                            console.log("Failed because of:",payload);
                        }
                        this.authorizedRequest(url,options,callback,onProgress);
                    });
                } else if ([3, 5, 6, 7].indexOf(err.code) > -1) {
                    this.logout();
                    callback(res);
                }
            } else {
                callback(res);
            }
        },onProgress);
    }

    checkRequest() {
        // HOTFIX for overview, why soever
        if (this.request === undefined) {
            this.request = require('./../util/Helper.js').httpRequest;
        }
    }
    
    authUser(username, password, callback) {
        this.checkRequest();

        this.request(this.apiBase+'/authentication/jwt', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            payload: {
                'username' : username,
                'password' : password
            }
        },(res) => {
            if (res.payload.error === null){
                localStorage.setItem('DAStudioAuthToken',res.payload.auth.authToken);
                localStorage.setItem('DAStudioRefreshToken',res.payload.auth.refreshToken);
                this.isLoggedIn = true;
                this.dispatcher.dispatch("logged_in");
            } else {
                this.dispatcher.dispatch("unauthorized");
            }
            callback(res.payload.error);
        }, (progress) => {
            
        });
    }
    
    logout(){
        if (localStorage.getItem('DAStudioAuthToken') !== null){
            localStorage.removeItem('DAStudioAuthToken');
        }
        if (localStorage.getItem('DAStudioRefreshToken') !== null){
            localStorage.removeItem('DAStudioRefreshToken');
        }
        this.isLoggedIn = false;
        this.dispatcher.dispatch("logged_out");
    }
    
    refreshToken(callback){
        let refresh = localStorage.getItem('DAStudioRefreshToken');
        this.dispatcher.dispatch("logging_in");
        if (refresh !== null) {
            this.checkRequest();
            this.request(this.apiBase+'/authentication/jwt/refresh', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                payload: {
                    refreshToken: refresh
                }
            },(res) => {
                if (res.payload.error === null){
                    localStorage.setItem('DAStudioAuthToken',res.payload.result.authToken);
                    localStorage.setItem('DAStudioRefreshToken',res.payload.result.refreshToken);
                    this.isLoggedIn = true;
                    this.dispatcher.dispatch("logged_in");
                    callback();
                } else {
                    this.logout();
                    callback(res);
                }
            });
        } else {
            this.logout();
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/login/auth.js